import { CModal, CModalHeader, CModalTitle, CModalBody } from '@coreui/react'
import ChartWrapper from './ChartWrapper'

function Modal({ open, onClose, type, title, children }) {

  return (
    <CModal size={type == 'pie'?"lg":"xl"}  alignment="center" visible={open} onClose={onClose}>
      <CModalHeader>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>{children}</CModalBody>
    </CModal>
  )
}

export default Modal
